import { createAsyncThunk } from "@reduxjs/toolkit";
import { Base_URL, ApiCall } from "../../Common/Path";
import { secureTokenManager } from "../../utils/secureTokenManager";

//User Status Calls
export const GetUserStatusTable = createAsyncThunk(
  "GetUserStatusTable",
  async ({ skip = 0, take = 20 } = {}) => {
    try {
      const response = await ApiCall(
        `${Base_URL}/users/all/INVESTOR?skip=${skip}&take=${take}`,
        "",
        "get"
      );
      return response;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);
export const UserStatusChange = createAsyncThunk(
  "UserStatusChange",
  async (body, { rejectWithValue }) => {
    const apiUrl = `${Base_URL}/user/status`;

    try {
      const response = await ApiCall(apiUrl, body, "put");
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const UserKycChange = createAsyncThunk(
  "UserKycChange",
  async (body, { rejectWithValue }) => {
    const apiUrl = `${Base_URL}/kyc/status`;

    try {
      const response = await ApiCall(apiUrl, body, "PATCH");
      if (response?.statusCode === 200) {
        const responseDataWithBody = {
          ...response,
          data: body,
        };
        return responseDataWithBody;
      } else {
        return response;
      }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
//
export const GetUserCustodianById = createAsyncThunk(
  "GetUserCustodianById",
  async ({ userRoleId}) => {
    try {
      const response = await ApiCall(`${Base_URL}/custodians/selected?userRoleId=${userRoleId}`);
      return response;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

//Custodian Account Calls
export const GetCustodianAccountTable = createAsyncThunk(
  "GetCustodianAccountTable",
  async (name) => {
    try {
      const response = await ApiCall(
        `${Base_URL}/user/custodians/get-custodian-client?custodian=${name}`,
        "",
        "get"
      );
      return response;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);
export const GetUserCustodian = createAsyncThunk(
  "GetUserCustodian",
  async (id) => {
    try {
      const response = await ApiCall(`${Base_URL}/custodians/selected/${id}/keys`, "", "get");
      return response;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);
//update user custodian
export const UpdateUserCustodian = createAsyncThunk(
  "UpdateUserCustodian",
  async ({ custId, keys }) => {
    try {
      const response = await ApiCall(
        `${Base_URL}/custodians/selected/${custId}/keys`,
        keys,
        "put"
      );
      if (response?.statusCode === 200) {
        const responseDataWithBody = {
          ...response,
          data: keys,
        };
        return responseDataWithBody;
      } else {
        return response;
      }
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

//User Kyc Details Calls
// export const GetUserKyc = createAsyncThunk("GetUserKyc", async ({body}) => {
//   try {
//     const response = await ApiCall(
//       `${Base_URL}/kyc/questions`,
//       body,
//       "POST"
//     );
//     return response;
//   } catch (error) {
//     throw error.response ? error.response.data : error.message;
//   }
// });

export const GetUserKyc = createAsyncThunk("GetUserKyc", async ({body}) => {
  try {
    // Extract the first object from the body array
    const requestData = Array.isArray(body) ? body[0] : body;
    const { type, custodians } = requestData; 
    // Build the custodians query parameters
    const custodianParams = custodians.map(custodian => `custodians=${encodeURIComponent(custodian)}`).join('&');
    const url = `${Base_URL}/kyc/all-questions?${custodianParams}&type=${encodeURIComponent(type)}`;
    const response = await ApiCall(
      url,
      "",
      "GET"
    );
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});

export const GetFileInfo = createAsyncThunk("GetFileInfo", async (fileName) => {
  try {
    const response = await ApiCall(
      `${Base_URL}/user/download/${fileName}`,
      "",
      "get"
    );
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});
//Get UserNames
export const GetAllUsersName = createAsyncThunk("GetAllUsersName", async () => {
  try {
    const response = await ApiCall(
      `${Base_URL}/user/get-users-names`,
      "",
      "get"
    );
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});
//Register User
export const RegisterUser = createAsyncThunk("RegisterUser", async (body) => {
  try {
    const response = await ApiCall(`${Base_URL}/user/register`, body, "post");
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});

export const GetCustodianTable = createAsyncThunk(
  "GetCustodianTable",
  async () => {
    try {
      const response = await ApiCall(`${Base_URL}/custodians`);
      return response;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const AddCustodians = createAsyncThunk(
  "AddCustodians",
  async (values) => {
    try {
      const response = await ApiCall(
        `${Base_URL}/strategy/custodian`,
        values,
        "post"
      );
      return response;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const CreateKYC = createAsyncThunk(
  "CreateKYC",
  async ({ body, method }) => {
    try {
      const response = await ApiCall(`${Base_URL}/kyc/questions`, body, method);
      return response;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);
export const DeleteKYC = createAsyncThunk("DeleteKYC", async (id) => {
  try {
    const response = await ApiCall(`${Base_URL}/kyc/questions/${id}`, null, 'DELETE');
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});


export const RestoreQuestion = createAsyncThunk("RestoreQuestion", async (id) => {
  try {
    const response = await ApiCall(`${Base_URL}/kyc/questions/${id}/restore`, null, 'PATCH');
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});


export const DeleteSection = createAsyncThunk("DeleteSection", async (section) => {
  try {
    // Create the URL with the exact section name using template literals
    const url = Base_URL + '/kyc/questions/sections/' + section;
    
    const response = await ApiCall(
      url,
      null, 
      'DELETE'
    );
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});

export const GetUserRoles = createAsyncThunk("GetUserRoles", async (type) => {
  const result = await ApiCall(`${Base_URL}/users/roles?portal=${type}`, "", "get");
  return result;
});



export const AddSubRoles = createAsyncThunk("AddSubRoles", async (body) => {
  const result = await ApiCall(`${Base_URL}/users`, body, "post");
  return result;
});

//GetChildRoles

export const GetChildRoles = createAsyncThunk("GetChildRoles", async () => {
  const result = await ApiCall(`${Base_URL}/users/child-parent-roles`, "", "get");
  return result;
});

export const GetApiPermission = createAsyncThunk("GetApiPermission", async ({ groupRole}) => {
  // Construct URL based on whether groupRole is provided
  const url = groupRole 
    ? `${Base_URL}/permissions/available-apis?groupRole=${groupRole}`
    : `${Base_URL}/permissions/available-apis`;
    
  const result = await ApiCall(url, "", "get");
  return result;
});

export const AddApiPermission = createAsyncThunk("AddApiPermission", async ({body}) => {
  const result = await ApiCall(`${Base_URL}/permissions/access-control`, body, "post");
  return result;
});

export const GetUserApiPermission = createAsyncThunk("GetUserApiPermission", async ({ parentId}) => {
  const result = await ApiCall(`${Base_URL}/permissions/access-control?parentRoleId=${parentId}`, "", "get");
  return result;
});

export const GetUserChildPermission = createAsyncThunk("GetUserChildPermission", async ({childRoleId}) => {
  const result = await ApiCall(`${Base_URL}/permissions/allowed-child-access?childRoleId=${childRoleId}`, "", "get");
  return result;
});


export const GetUsers = createAsyncThunk("GetUsers", async () => {
  const result = await ApiCall(`${Base_URL}/users/child-parent-roles`, "", "get");
  return result;
});



export const GetUserInfo = createAsyncThunk(
  "GetUserInfo",
  async ({ type, id }) => {
    try {
      const url = id
        ? `${Base_URL}/users/info?parentRoleId=${id}`
        : `${Base_URL}/users/info`;

      const response = await ApiCall(url);

      return response;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);


export const DeletetUser = createAsyncThunk(
  "DeletetUser",
  async ({ id }, { rejectWithValue }) => {
    try {
      const url = `${Base_URL}/users/child-role?id=${id}`;
      const response = await ApiCall(url, null, "delete");
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response
          ? error.response.data
          : "An error occurred while deleting the user"
      );
    }
  }
);


export const GetLogs = createAsyncThunk(
  "GetLogs",
  async ({ id}) => {
    try {
      const url = `${Base_URL}/logger/logs?parentRoleId=${id}`;
      const result = await ApiCall(url, null, "get");
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);


export const GetKycById = createAsyncThunk(
  "GetKycById",
  async ({kycId, body}) => {
    try {
      const url = `${Base_URL}/kyc/${kycId}`;
      const result = await ApiCall(url, body, "post");
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const GetIBKRkycmapping = createAsyncThunk(
  "GetIBKRkycmapping",
  async (type) => {
    try {
      const url = `${Base_URL}/kyc/ibkr/fields?accountType=${type}`;
      const result = await ApiCall(url, '', "get");
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const GetAllRoles = createAsyncThunk("GetAllRoles", async () => {
  const result = await ApiCall(`${Base_URL}/users/all-roles`, "", "get");
  return result;
});

export const CreateSubRoleGroup = createAsyncThunk("CreateSubRoleGroup", async (body) => {
  const result = await ApiCall(`${Base_URL}/users/role-groups`, body, "post");
  return result;
});

export const GetRoleGroups = createAsyncThunk("GetRoleGroups", async () => {
  const result = await ApiCall(`${Base_URL}/users/role-groups`, "", "get");
  return result;
});

export const GetRoleGroupPermissions = createAsyncThunk("GetRoleGroupPermissions", async (groupId) => {
  const result = await ApiCall(`${Base_URL}/users/role-groups/${groupId}/permissions`, "", "get");
  return result;
});

export const UpdateRoleGroupPermissions = createAsyncThunk("UpdateRoleGroupPermissions", async ({groupId, body}) => {
  const result = await ApiCall(`${Base_URL}/users/role-groups/${groupId}/permissions`, body, "put");
  return result;
});

export const TwoFactorSetup = createAsyncThunk("TwoFactorSetup", async () => {
  try {
    const response = await ApiCall(`${Base_URL}/2fa/setup`, "", "post");
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});

export const EnableTwoFactor = createAsyncThunk("EnableTwoFactor", async (body) => {
  try {
    const response = await ApiCall(`${Base_URL}/2fa/enable`, body, "post");
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});

export const DisableTwoFactor = createAsyncThunk("DisableTwoFactor", async () => {
  try {
    const response = await ApiCall(`${Base_URL}/2fa/disable`, "", "post");
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});

export const GetNotification = createAsyncThunk(
  "GetNotification",
  async ({role}, { rejectWithValue }) => {
    try {
      // SECURITY FIX: Basic validation to prevent role manipulation while maintaining functionality
      
      // Basic authentication check
      const token = secureTokenManager.getAccessToken();
      if (!token || token === 'null' || token === 'undefined') {
        return rejectWithValue("Authentication required");
      }
      
      // Validate role is from allowed set (prevent arbitrary role injection)
      const allowedRoles = ['ADMIN', 'SUPER_ADMIN', 'USER', 'MANAGER', 'KYC_MANAGER', 'ASSET_MANAGER'];
      if (!role || !allowedRoles.includes(role.toUpperCase())) {
        console.warn('Potentially invalid role specified:', role);
        // Don't reject, let server handle authorization
      }
      
      // Update last activity for session management
      localStorage.setItem('lastActivity', Date.now().toString());
      
      const url = `${Base_URL}/notifications`;
      const result = await ApiCall(url, null, "get");
      return result;
    } catch (error) {
      console.error("Error fetching notifications:", error);
      return rejectWithValue(
        error.response?.data?.message || 
        error.message || 
        "An error occurred while fetching notifications"
      );
    }
  }
);

export const ChangeNotificationStatus = createAsyncThunk(
  "ChangeNotificationStatus",
  async ({id, body}) => {
    try {
      const url = `${Base_URL}/notifications/${id}`;
      const result = await ApiCall(url, body, "PATCH");
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const ChangeAllNotificationStatus = createAsyncThunk("ChangeAllNotificationStatus", async (type, { getState }) => {
  const {token} = getState().auth;
  const result = await ApiCall(`${Base_URL}/notifications/read-all`, "", "put", token);
  return result;
});

export const PortalBasedRoles = createAsyncThunk(
  "PortalBasedRoles",
  async ({type, roleType}) => {
    try {
      // const url = `${Base_URL}/permissions/group-permissions?groupRole=${roleType}`;
      const url = `${Base_URL}/permissions/groups?groupRole=${roleType}`;
      const result = await ApiCall(url, null, "get");
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const AddGroupRole = createAsyncThunk("AddGroupRole", async (body) => {
  try {
    const response = await ApiCall(`${Base_URL}/permissions/groups`, body, "post");
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});

export const UpdateGroupRole = createAsyncThunk("UpdateGroupRole", async ({Id, body}) => {
  try {
    const response = await ApiCall(`${Base_URL}/permissions/groups/${Id}`, body, "PATCH");
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});

export const IBKRAccountdetails = createAsyncThunk(
  "IBKRAccountdetails",
  async () => {
    try {
      const url = `${Base_URL}/ibkr/account-id`;
      const result = await ApiCall(url, null, "get");
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

// Household Management Calls
export const GetHouseholds = createAsyncThunk(
  "GetHouseholds",
  async ({ isActive } = {}) => {
    try {
      let url = `${Base_URL}/households`;

      // Optional filter by active status
      if (typeof isActive === "boolean") {
        url += `?isActive=${isActive}`;
      }

      const response = await ApiCall(url, "", "get");
      return response;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);